var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.868,
    height: 21.869,
    viewBox: "0 0 21.868 21.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    d: "M276.323,64.538,273.6,61.82l-5.061,5.1,2.719,2.718Zm0,0",
    transform: "translate(-257.095 -59.18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    d: "M210.382,209.338a.641.641,0,0,0,.839.838l3.254-1.683-2.411-2.411Zm0,0",
    transform: "translate(-201.369 -197.279)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    d: "M412.518,2.906a.641.641,0,0,0,0-.906L410.706.188a.641.641,0,0,0-.906,0l-1.547,1.547,2.718,2.718Zm0,0",
    transform: "translate(-390.838 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    d: "M2.422,133.813h.641v3.246a.641.641,0,0,0,1.094.453l3.7-3.7h7.466a1.924,1.924,0,0,0,1.922-1.922V125.53l-2.021,2.021a1.9,1.9,0,0,1-.613.412l-3.668,1.9a2.023,2.023,0,0,1-.839.195,1.893,1.893,0,0,1-.552-.091H4.984a.641.641,0,1,1,0-1.281H8.229a1.918,1.918,0,0,1,.1-1.291l1.977-3.84a1.752,1.752,0,0,1,.371-.524L12.712,121H2.422A1.924,1.924,0,0,0,.5,122.922v8.97a1.924,1.924,0,0,0,1.922,1.922Zm0,0",
    transform: "translate(-0.5 -115.832)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareBlog);
export default __webpack_public_path__ + "static/media/care-blog.634262fecda22ba1c563bf3b51ee9e08.svg";
export { ForwardRef as ReactComponent };